import * as Yup from 'yup'

export const getInitialValues = ({
    email_notifications,
    text_notifications,
}) => ({
    email_notifications: Boolean(email_notifications) || false,
    text_notifications: Boolean(text_notifications) || false,
})

export const validationSchema = Yup.object().shape({
    email_notifications: Yup.boolean(),
    text_notifications: Yup.boolean(),
})
